/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './personal_attributes';
import './business_attributes';
import '../../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "identityverifier": {
        "nested": {
          "model": {
            "nested": {
              "CorrectedData": {
                "fields": {
                  "rawPersonalId": {
                    "type": "string",
                    "id": 7
                  },
                  "personalIdFideliusToken": {
                    "type": "string",
                    "id": 8
                  }
                },
                "nested": {
                  "personal_id": {
                    "oneof": ["rawPersonalId", "personalIdFideliusToken"]
                  }
                }
              },
              "Decision": {
                "fields": {
                  "verified": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "comment": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "Interpretation": {
                "fields": {
                  "matchResults": {
                    "type": "squareup.identityverifier.model.Result",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "correctedData": {
                    "type": "squareup.identityverifier.model.CorrectedData",
                    "id": 2,
                    "rule": "optional"
                  },
                  "warnings": {
                    "type": "squareup.identityverifier.model.Warning",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "personalAttributes": {
                    "type": "squareup.identityverifier.model.PersonalAttributes",
                    "id": 5
                  },
                  "businessAttributes": {
                    "type": "squareup.identityverifier.model.BusinessAttributes",
                    "id": 7
                  }
                },
                "nested": {
                  "vendor_data": {
                    "oneof": ["personalAttributes", "businessAttributes"]
                  }
                }
              },
              "InteractiveUserSession": {
                "fields": {
                  "vendorName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "userFormUrl": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sessionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "resubmissionsRequested": {
                    "type": "int32",
                    "id": 4,
                    "rule": "optional"
                  },
                  "sessionStatus": {
                    "type": "squareup.identityverifier.model.InteractiveUserSession.SessionStatus",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SessionStatus": {
                    "values": {
                      "RESUBMISSION_REQUESTED": 1,
                      "AWAITING_SUBMISSION": 2,
                      "SUBMITTED": 3
                    }
                  }
                }
              },
              "Result": {
                "fields": {
                  "attribute": {
                    "type": "squareup.identityverifier.model.Result.Attribute",
                    "id": 1,
                    "rule": "optional"
                  },
                  "strength": {
                    "type": "squareup.identityverifier.model.Result.Strength",
                    "id": 2,
                    "rule": "optional"
                  },
                  "comment": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Attribute": {
                    "values": {
                      "ATTRIBUTE_DO_NOT_USE": 0,
                      "FULL_NAME": 1,
                      "ADDRESS": 2,
                      "DATE_OF_BIRTH": 3,
                      "PERSONAL_ID": 4,
                      "PHONE_NUMBER": 5,
                      "PASSPORT": 6,
                      "DRIVERS_LICENSE": 7,
                      "BUSINESS_ID_ABN": 8,
                      "BUSINESS_ID_INCORP": 9,
                      "BUSINESS_ID_VAT": 10,
                      "BUSINESS_ID_SIREN": 11,
                      "BUSINESS_ID_SIRET": 12,
                      "BUSINESS_ID_EIN": 13,
                      "BUSINESS_ID_CIK": 14,
                      "BUSINESS_ID_LEI": 15,
                      "BUSINESS_ID_TIN": 16,
                      "BUSINESS_ID_TRADE_RN": 17,
                      "BUSINESS_DIRECTORS_LOOKUP": 18,
                      "BUSINESS_BENEFICIAL_OWNERS_LOOKUP": 19,
                      "BUSINESS_ID_ACN": 20,
                      "BUSINESS_ID_NIF": 21,
                      "BUSINESS_PARTNERS_LOOKUP": 22,
                      "BUSINESS_NAME": 23,
                      "BUSINESS_ADDRESS": 24,
                      "BUSINESS_LOCALITY": 25,
                      "BUSINESS_POSTAL_CODE": 26,
                      "BUSINESS_STATE_PROVINCE": 27,
                      "BUSINESS_STREET_NAME": 28,
                      "BUSINESS_STREET_TYPE": 29,
                      "BUSINESS_ID_BRN": 30,
                      "BUSINESS_BUILDING_NUMBER": 31,
                      "BUSINESS_ID_CHRN": 32,
                      "BUSINESS_ID_CORPORATE_NUMBER": 33
                    }
                  },
                  "Strength": {
                    "values": {
                      "STRENGTH_DO_NOT_USE": 0,
                      "UNMATCHED": 1,
                      "EXACT": 2,
                      "FUZZY": 3
                    }
                  }
                }
              },
              "Verification": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "productIntent": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "clientKey": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "clientComment": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "createdAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  },
                  "inProgressStatus": {
                    "type": "squareup.identityverifier.model.Verification.InProgressStatus",
                    "id": 6
                  },
                  "completedStatus": {
                    "type": "squareup.identityverifier.model.Verification.CompletedStatus",
                    "id": 7
                  },
                  "erroredStatus": {
                    "type": "squareup.identityverifier.model.Verification.ErroredStatus",
                    "id": 8
                  }
                },
                "nested": {
                  "InProgressStatus": {
                    "fields": {
                      "interactiveUserSessions": {
                        "type": "squareup.identityverifier.model.InteractiveUserSession",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  },
                  "CompletedStatus": {
                    "fields": {
                      "completedAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "decision": {
                        "type": "squareup.identityverifier.model.Decision",
                        "id": 2,
                        "rule": "optional"
                      },
                      "correctedData": {
                        "type": "squareup.identityverifier.model.CorrectedData",
                        "id": 3,
                        "rule": "optional"
                      },
                      "personalAttributes": {
                        "type": "squareup.identityverifier.model.PersonalAttributes",
                        "id": 5
                      },
                      "businessAttributes": {
                        "type": "squareup.identityverifier.model.BusinessAttributes",
                        "id": 7
                      }
                    },
                    "nested": {
                      "vendor_data": {
                        "oneof": ["personalAttributes", "businessAttributes"]
                      }
                    }
                  },
                  "ErroredStatus": {
                    "fields": {
                      "erroredAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 1,
                        "rule": "optional"
                      },
                      "cause": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "status": {
                    "oneof": ["inProgressStatus", "completedStatus", "erroredStatus"]
                  }
                }
              },
              "Warning": {
                "values": {
                  "WARNING_DO_NOT_USE": 0,
                  "PERSONAL_ID_ISSUED_BEFORE_DOB": 1,
                  "DECEASED": 2,
                  "IDENTITY_OVERUSED": 3,
                  "PO_BOX_ADDRESS": 4,
                  "WARM_ADDRESS": 5,
                  "UNDER_MINIMUM_AGE": 6,
                  "CREDIT_CHECK_FAILED": 7,
                  "POOR_IMAGE_QUALITY": 8,
                  "STOLEN_DOCUMENT": 9,
                  "EXPIRED_DOCUMENT": 10
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.CorrectedData && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Decision && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Interpretation && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.InteractiveUserSession && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.InteractiveUserSession?.nested?.SessionStatus && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Result && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Result?.nested?.Attribute && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Result?.nested?.Strength && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Verification && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Verification?.nested?.InProgressStatus && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Verification?.nested?.CompletedStatus && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Verification?.nested?.ErroredStatus && !$root.nested?.squareup?.nested?.identityverifier?.nested?.model?.nested?.Warning) {
  $root.addJSON(jsonData);
}

/**
 * Container for data returned by the vendor as suggested correction.
 *
 * SOURCE CorrectedData @ squareup/identityverifier/model/verification.proto at 15:1
 */
export const CorrectedData = $root.lookupType('squareup.identityverifier.model.CorrectedData');
fixType(CorrectedData);
Builder.createAndAttachToType(CorrectedData);
/**
 * A final decision for a successfully completed verification.
 *
 * SOURCE Decision @ squareup/identityverifier/model/verification.proto at 33:1
 */
export const Decision = $root.lookupType('squareup.identityverifier.model.Decision');
fixType(Decision, {
  comment: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Decision);
/**
 * Interpretation for the results of either a vendor interaction or a verification.
 *
 * SOURCE Interpretation @ squareup/identityverifier/model/verification.proto at 42:1
 */
export const Interpretation = $root.lookupType('squareup.identityverifier.model.Interpretation');
fixType(Interpretation);
Builder.createAndAttachToType(Interpretation);
/**
 * Session the end user must complete interactively to move the verification forward. This typically
 * involves redirecting the user to a form on a vendor's website to provide additional information,
 * or invoking a vendor's native SDK (iOS, Android) to collect the information.
 *
 * SOURCE InteractiveUserSession @ squareup/identityverifier/model/verification.proto at 79:1
 */
export const InteractiveUserSession = $root.lookupType('squareup.identityverifier.model.InteractiveUserSession');
fixType(InteractiveUserSession, {
  vendorName: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(InteractiveUserSession);
/**
 * SOURCE SessionStatus @ squareup/identityverifier/model/verification.proto at 98:3
 */
InteractiveUserSession.SessionStatus = $root.lookupEnum('squareup.identityverifier.model.InteractiveUserSession.SessionStatus').values;
/**
 * Container for the match results of a single attribute.
 *
 * SOURCE Result @ squareup/identityverifier/model/verification.proto at 109:1
 */
export const Result = $root.lookupType('squareup.identityverifier.model.Result');
fixType(Result, {
  attribute: {
    required: true
  },
  strength: {
    required: true
  }
});
Builder.createAndAttachToType(Result);
/**
 * List of attributes that can be matched.
 *
 * SOURCE Attribute @ squareup/identityverifier/model/verification.proto at 124:3
 */
Result.Attribute = $root.lookupEnum('squareup.identityverifier.model.Result.Attribute').values;
/**
 * Strength of an attribute match.
 *
 * SOURCE Strength @ squareup/identityverifier/model/verification.proto at 196:3
 */
Result.Strength = $root.lookupEnum('squareup.identityverifier.model.Result.Strength').values;
/**
 * The verification resource.
 *
 * SOURCE Verification @ squareup/identityverifier/model/verification.proto at 215:1
 */
export const Verification = $root.lookupType('squareup.identityverifier.model.Verification');
fixType(Verification, {
  id: {
    notEmpty: true
  },
  productIntent: {
    notEmpty: true
  },
  clientKey: {
    notEmpty: true
  },
  createdAt: {
    required: true
  }
});
Builder.createAndAttachToType(Verification);
/**
 * Data container for verifications that are currently in progress.
 *
 * SOURCE InProgressStatus @ squareup/identityverifier/model/verification.proto at 263:3
 */
Verification.InProgressStatus = $root.lookupType('squareup.identityverifier.model.Verification.InProgressStatus');
fixType(Verification.InProgressStatus);
Builder.createAndAttachToType(Verification.InProgressStatus);
/**
 * Data container for verifications that have completed successfully, i.e. for which there is
 * a final Decision (and possibly some corrected data).
 *
 * SOURCE CompletedStatus @ squareup/identityverifier/model/verification.proto at 272:3
 */
Verification.CompletedStatus = $root.lookupType('squareup.identityverifier.model.Verification.CompletedStatus');
fixType(Verification.CompletedStatus, {
  completedAt: {
    required: true
  },
  decision: {
    required: true
  }
});
Builder.createAndAttachToType(Verification.CompletedStatus);
/**
 * Data container for verifications that terminate in an error condition, i.e. for which a final
 * decision cannot be produced.
 *
 * SOURCE ErroredStatus @ squareup/identityverifier/model/verification.proto at 305:3
 */
Verification.ErroredStatus = $root.lookupType('squareup.identityverifier.model.Verification.ErroredStatus');
fixType(Verification.ErroredStatus, {
  erroredAt: {
    required: true
  },
  cause: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(Verification.ErroredStatus);
/**
 * List of possible warnings/risk alerts from vendors.
 *
 * SOURCE Warning @ squareup/identityverifier/model/verification.proto at 315:1
 */
export const Warning = $root.lookupEnum('squareup.identityverifier.model.Warning').values;